import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileElm } from 'src/app/utils/interfaces';
import { Clipboard } from '@angular/cdk/clipboard';

export interface IStorageConfirmationModalDefault {
  file: FileElm;
}

@Component({
  selector: 'app-storage-confirmation-modal',
  templateUrl: './storage-confirmation-modal.component.html',
  styleUrls: ['./storage-confirmation-modal.component.scss']
})
export class StorageConfirmationModalComponent implements OnInit {
  public file: FileElm;

  public value: string;

  constructor(
    public dialogRef: MatDialogRef<StorageConfirmationModalComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public defaults: IStorageConfirmationModalDefault,
    private clipboard: Clipboard
  ) {
    this.file = defaults.file;
  }

  ngOnInit(): void {
    return;
  }

  validate(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  copy(): void {
    this.clipboard.copy(this.file.name);
  }
}
